export default __webpack_public_path__ + "02141ef2139e0de5d180b5b76dff1982.png";